/* global _:false */

import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class UploadService extends InjectableClass {
  constructor(Upload, uploadFileTypes) {
    'ngInject';

    super({ Upload, uploadFileTypes });
  }

  upload(file, url) {
    return this.Upload.upload({
      url,
      data: { file },
    });
  }

  createFilePattern(acceptFileTypes) {
    // file upload wants pattern like "'application/pdf'" the '' are needed to make component work
    return `'${_.map(
      acceptFileTypes,
      (type) => this.uploadFileTypes[type] || type
    ).join(',')}'`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/file-upload.service.js